import { render, staticRenderFns } from "./CookiesUpdate.vue?vue&type=template&id=1cec89ef&scoped=true&"
import script from "./CookiesUpdate.vue?vue&type=script&lang=js&"
export * from "./CookiesUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CookiesUpdate.vue?vue&type=style&index=0&id=1cec89ef&prod&lang=css&"
import style1 from "./CookiesUpdate.vue?vue&type=style&index=1&id=1cec89ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cec89ef",
  null
  
)

export default component.exports